'use strict';

var styled = require('styled-components');
var React = require('react');
var index = require('../Flex/index.js');
var reactElements = require('../../helpers/react-elements.js');
var Tab = require('./Tab.js');
var Tab_styles = require('./Tab.styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);

/* eslint-disable @typescript-eslint/no-non-null-assertion */
const tabInvalidChildrenError = '<Tabs /> can only have <Tab /> as children';
const isTabElement = reactElements.isElementOfType(Tab.Tab);
const toTabElement = (child) => {
    const tabElement = child;
    if (!isTabElement(tabElement)) {
        throw new Error(tabInvalidChildrenError);
    }
    return tabElement;
};
const UnstyledTabs = React.forwardRef(({ children, variant, activeTab, onActiveTabChange, ...props }, ref) => (React__default.default.createElement(index.Flex.Row, { ...props, space: "m", ref: ref, role: "tablist" }, React.Children.map(children, child => {
    const tab = toTabElement(child);
    return (React__default.default.createElement(Tab.Tab, { ...tab.props, name: tab.props.name, "aria-controls": `tabpanel_${tab.props.name}`, key: tab.props.name, role: "tab", "aria-selected": tab.props.name === activeTab, onClick: (event) => {
            tab.props.onClick?.(event);
            onActiveTabChange?.(tab.props.name);
        } }));
}))));
const Tabs = styled__default.default(UnstyledTabs) `
  ${Tab.Tab} {
    ${({ variant }) => Tab_styles.tabStylesByVariant[variant].normal}
  }
  ${Tab.Tab}[name="${({ activeTab }) => activeTab}"] {
    ${({ variant }) => Tab_styles.tabStylesByVariant[variant].active}
  }
`;
Tabs.defaultProps = {
    variant: 'default',
};

exports.Tabs = Tabs;
exports.tabInvalidChildrenError = tabInvalidChildrenError;
//# sourceMappingURL=Tabs.js.map
